import type { SvgIconComponent } from '@mui/icons-material';
import { Box, Card, Container, Stack, Typography } from '@mui/material';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import { useT } from '../../i18n';

const FEATURES: { icon: SvgIconComponent; key: string }[] = [
  { icon: CampaignRoundedIcon, key: 'landing.features.announcements' },
  { icon: ReceiptLongRoundedIcon, key: 'landing.features.billing' },
  { icon: EventAvailableRoundedIcon, key: 'landing.features.facilities' },
  { icon: ReportProblemRoundedIcon, key: 'landing.features.complaints' },
  { icon: ShieldRoundedIcon, key: 'landing.features.security' },
  { icon: BarChartRoundedIcon, key: 'landing.features.reports' },
];

export function Features() {
  const t = useT();

  return (
    <Box component="section" id="fitur" sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Typography variant="h3" fontWeight={700} sx={{ maxWidth: 640, letterSpacing: '-0.3px' }}>
          {t('landing.features.title')}
        </Typography>
        <Box
          sx={{
            mt: 4,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {FEATURES.map(({ icon: Icon, key }) => (
            <Card key={key} variant="outlined" sx={{ p: 2.5 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 2,
                    bgcolor: 'action.selected',
                    color: 'secondary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Icon />
                </Box>
                <Typography variant="subtitle1" fontWeight={500}>
                  {t(key)}
                </Typography>
              </Stack>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
